/**
 * Safe localStorage/sessionStorage wrapper that handles:
 * - Safari Private Browsing mode
 * - Storage disabled by user settings
 * - SecurityError from restricted environments
 * 
 * Never throws - always returns fallback values on failure
 */

export const safeStorage = {
  getItem(key: string, fallback: string | null = null): string | null {
    try {
      return localStorage.getItem(key) ?? fallback;
    } catch (e) {
      console.warn(`[safeStorage] Failed to get "${key}" from localStorage:`, e);
      return fallback;
    }
  },

  setItem(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.warn(`[safeStorage] Failed to set "${key}" in localStorage:`, e);
      return false;
    }
  },

  removeItem(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      console.warn(`[safeStorage] Failed to remove "${key}" from localStorage:`, e);
      return false;
    }
  },
};

export const safeSessionStorage = {
  getItem(key: string, fallback: string | null = null): string | null {
    try {
      return sessionStorage.getItem(key) ?? fallback;
    } catch (e) {
      console.warn(`[safeSessionStorage] Failed to get "${key}" from sessionStorage:`, e);
      return fallback;
    }
  },

  setItem(key: string, value: string): boolean {
    try {
      sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.warn(`[safeSessionStorage] Failed to set "${key}" in sessionStorage:`, e);
      return false;
    }
  },

  removeItem(key: string): boolean {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (e) {
      console.warn(`[safeSessionStorage] Failed to remove "${key}" from sessionStorage:`, e);
      return false;
    }
  },
};
